import Calendar, { OnClickFunc, TileClassNameFunc } from 'react-calendar';
import lahiruka_logo from './assets/lahiruka_logo.png';
import { Title, CalendarContainer, Viikot } from './Styled';
import { useState, useCallback, useEffect } from 'react';
import { Booking, fetchBookings, getBooking, isBooked, isEndDate, isStartDate } from './calendarController';
import { DetailCard, DetailCardEdit } from './Details';

export const CalendarView = () => {

    const currentYear = new Date().getFullYear();
    const minDate = new Date(currentYear - 1, 0, 1);
    const maxDate = new Date(currentYear + 1, 11, 31);

    const [booking, setBooking] = useState<Booking | null>(null);
    const [selection, setSelection] = useState<Date | null>(null);
    const [ edit, setEdit ] = useState<Booking| null> (null);
    const Container = CalendarContainer();

    useEffect(() => {
        const fetchOnce = async () => {
            await fetchBookings();
        }
        fetchOnce();
    }, []);

    const onClickDay: OnClickFunc = useCallback((value) => {
        const val = getBooking(value);
        setBooking(val);
        setSelection(value);

    }, []);

    const tileClassName: TileClassNameFunc = useCallback(({ date }) => {
        if(isStartDate(date) && isEndDate(date)) {
            return "exchangeDate";
        } else if (isStartDate(date)) {
            return "startDate";
        } else if (isEndDate(date)) {
            return "endDate";
        } else if (isBooked(date)) {
            return "booked";
        }
        return '';
    }, []);

    return (
        <Container>
            <Title>
                <img src={lahiruka_logo} alt="Lahiruka Logo" />
            </Title>

            <Calendar
                showWeekNumbers={true}
                minDetail="year"
                next2Label={null}
                prev2Label={null}
                onClickDay={onClickDay}
                tileClassName={tileClassName}
                locale="fi-FI"
                value={selection}
                minDate={minDate}
                maxDate={maxDate}
            />

            { booking && !edit ? (
                <DetailCard booking={booking} setEdit={setEdit} />
            ) : selection || edit ? (
                <DetailCardEdit date={selection} setBooking={setBooking} />
            ) : null}

            <Viikot>
                <p>{"Parannus ehdotukset Jussille :)"}</p>
                <span>
                    {
                        /*freeWeeks.map((week) => `-${week}- `)*/
                    }
                </span>
            </Viikot>
        </Container>
    );
};
